var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currThemeObj && _vm.currThemeObj.cssStyle),expression:"currThemeObj && currThemeObj.cssStyle"}],style:({
    '--mixtmt_whiteColor': _vm.currThemeObj.cssStyle.whiteColor,
    '--mixtmt_footer_bg': `url('/static/${_vm.currThemeObj.sportType}/${_vm.currThemeObj.imageUrl}/footer_bg.png')`,
  }),attrs:{"id":"cctv_footer"}},[_c('span',{staticClass:"companyName"},_vm._l((_vm.companyName),function(text,index){return _c('span',{key:index,domProps:{"textContent":_vm._s(text)}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }